import script from "./HelpOther.vue?vue&type=script&setup=true&lang=ts"
export * from "./HelpOther.vue?vue&type=script&setup=true&lang=ts"

import "./HelpOther.vue?vue&type=style&index=0&id=595a61d7&lang=scss&scoped=true"

import exportComponent from "/home/matriXagent/git/center-secure/product/ap/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-595a61d7"]])

export default __exports__